import styled, { breakpoints } from '../../../styles/theme';
import { CharacteristicsStyled } from '../CharacteristicsStyled';
import media from 'src/styles/media';
import { rem } from 'polished';

export const CharacteristicsStyledAC = styled(CharacteristicsStyled)`
    color: ${({ theme }) => theme.colors.grey5};
    background: #f5f5f5;

    .techWrapper {
        margin-left: ${rem(6)};
    }

    .details {
        .tech-point {
            @media (max-width: ${breakpoints.md}px) {
                padding-left: ${rem(10)};
            }
            span {
                font-size: ${({ theme }) => theme.fontSizes.h4};
                color: ${({ theme }) => theme.colors.grey5};
                margin-bottom: ${rem(10)};
            }
        }
    }

    .techBlock {
        .imageWrapper-fuel {
            svg {
                path {
                    stroke: ${({ theme }) => theme.colors.grey5};
                }
            }
        }
        .imageWrapper-gearbox {
            svg {
                height: ${rem(35)};

                g {
                    path {
                        fill: ${({ theme }) => theme.colors.grey5};
                    }
                }
            }
        }
    }

    .featureList {
        color: ${({ theme }) => theme.colors.grey5};

        li {
            color: ${({ theme }) => theme.colors.grey5};
            font-size: ${({ theme }) => theme.fontSizes.h4};

            svg {
                circle {
                    fill: ${({ theme }) => theme.colors.grey2};
                    stroke: ${({ theme }) => theme.colors.grey2};
                }

                line {
                    stroke: ${({ theme }) => theme.colors.white};
                }
            }

            @media (min-width: ${breakpoints.sm}px) {
                padding-left: ${rem(20)};
                color: ${({ theme }) => theme.colors.grey5};
                font-size: ${({ theme }) => theme.fontSizes.h4};
                padding-left: ${rem(20)};
                list-style: inside;

                @media (min-width: ${breakpoints.md}px) {
                    padding-left: 0;
                }
            }

            &:before {
                display: none;
            }
        }
    }

    .environmentalWrapper {
        background: ${({ theme }) => theme.colors.grey8};
        border-radius: ${rem(12)};

        span {
            color: ${({ theme }) => theme.colors.grey5};
        }
    }

    .technicalTitle {
        font-size: ${rem(34)};
    }

    .technicalFeaturesModule {
        @media (max-width: ${breakpoints.md}px) {
            margin-left: ${rem(10)};
        }
    }

    .technicalSubtitle {
        font-size: ${rem(22)};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        padding: ${rem(18)} 0 ${rem(12)} 0;

        @media (max-width: ${breakpoints.md}px) {
            margin-left: ${rem(10)};
        }
    }

    .techLabel {
        font-size: ${({ theme }) => theme.fontSizes.h5};
        text-transform: capitalize;
    }

    .technicalDetails {
        font-size: ${rem(18)};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        padding: 0;

        @media (max-width: ${breakpoints.md}px) {
            padding-left: ${rem(10)};
        }

        &.characteristics {
            font-size: ${rem(32)};
            font-weight: ${({ theme }) => theme.fontWeights.textRegular};
            line-height: 1.2;

            @media (max-width: ${breakpoints.md}px) {
                padding-left: ${rem(10)};
            }
        }
    }

    .technicalWrapper {
        border-top: none;
    }

    .technicalDetails-mainBlock {
        padding-left: ${rem('10px')};
    }

    .featureTitleWide {
        border-top: none;
        font-size: ${({ theme }) => theme.fontSizes.h5};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        letter-spacing: 0;
    }

    .Collapsible__trigger {
        padding-left: 0;
    }

    .Collapsible {
        background-color: #f5f5f5;
    }

    .legalText {
        a {
            color: ${({ theme }) => theme.colors.grey2};
            text-decoration: none;
        }
    }

    .featureTitle {
        font-size: ${({ theme }) => theme.fontSizes.h5};
    }

    .specificationBlock {
        padding-left: ${rem('10px')};

        ${media.xs`
            column-gap: 5%;
        `}
    }

    .hideTechnicalDetail {
        width: 100%;
    }

    .hideTechnicalDetailWrapper {
        a {
            color: ${({ theme }) => theme.colors.red};

            &:hover {
                color: ${({ theme }) => theme.colors.grey5};
            }
        }
    }

    .collapsibleTriggerHeader {
        & svg > path {
            fill: ${({ theme }) => theme.colors.red};
        }
    }

    .featureList {
        li {
            padding-left: ${rem('10px')};
        }
        .featureInfo {
            max-width: ${rem('250px')};
        }
    }
`;
